import { clsx } from '@team/clsx';
import { Props } from './types';
import { ForwardedRef, forwardRef } from 'react';

/**
 * Базовый корневой компонент
 */
export const Layout = forwardRef(function RootComponent<T>(
  { Component = 'div', baseClassName, className, ...props }: Props<T>,
  forwardedRef: ForwardedRef<T>
) {
  return (
    <Component
      className={clsx(className, baseClassName)}
      ref={forwardedRef}
      {...props}
    />
  );
});
